import type { BlogPost } from "./BlogPostPage";
import { doorwayTeamsPost } from "./DoorwayTeamsPostData";
import { seoAeoBlogPosts } from "./SeoAeoPostsData";

export const publishedBlogPosts = sortBlogPosts([
  doorwayTeamsPost,
  ...seoAeoBlogPosts,
]);

export function sortBlogPosts(posts: BlogPost[]): BlogPost[] {
  return [...posts].sort((left, right) => {
    const featuredDifference = Number(Boolean(right.featured)) - Number(Boolean(left.featured));
    if (featuredDifference !== 0) return featuredDifference;

    const dateDifference = Date.parse(right.publishedAt) - Date.parse(left.publishedAt);
    if (dateDifference !== 0) return dateDifference;

    return left.title.localeCompare(right.title);
  });
}
